import * as React from "react";

import { ProfileForm } from "@/components/auth";
import { Home, LayoutDashboard } from "lucide-react";
import { AppHeader } from "@/pages/shared/components/AppHeader";

export function ProfileContent() {
  const navLinks = [
    { to: "/", label: "Home", icon: <Home className="mr-2 h-4 w-4" /> },
    {
      to: "/dashboard",
      label: "Dashboard",
      icon: <LayoutDashboard className="mr-2 h-4 w-4" />,
    },
  ];

  return (
    <div className="min-h-screen bg-background">
      <AppHeader navLinks={navLinks} />

      <main className="container mx-auto px-4 py-8">
        <div className="mx-auto max-w-2xl">
          <h1 className="mb-8 text-3xl font-bold">Profile Settings</h1>
          <ProfileForm />
        </div>
      </main>
    </div>
  );
}

export default ProfileContent;
